<div class="container-fluid mt-5 pt-3">
    <div class="row mt-5" *ngIf="detalleLibro.response.list.length != 0">
        <div class="col-sm-12 mt-4">
            <a [routerLink]="['/']"><< Regresar</a>
        </div>
        <div class="col-sm-4">
            <div class="divImagenPortada">
                <!-- <img width="100%" src="{{detalleLibro.response.list[0].image}}"> -->
                <lib-ngx-image-zoom
                    [thumbImage]=urlImagen
                    [zoomMode]="hover"
                    [magnification]="0.3"
                    [scrollStepSize]="0.1"
                    [enableScrollZoom]="true"
                    [enableLens]="false"
                    [lensWidth]="100"
                ></lib-ngx-image-zoom>
                <p class="imagen-calidad-nota">
                    *La imagen mostrada es de calidad reducida. Al adquirir este producto, recibirá la imagen en alta resolución junto con la descripción completa.
                </p>
            </div>
            <!--daet-->
            <!--div class="divImagenPortada">
                <lib-ngx-image-zoom
                    [thumbImage]=urlImagen2
                    [zoomMode]="hover"
                    [magnification]="0.3"
                    [scrollStepSize]="0.1"
                    [enableScrollZoom]="true"
                    [enableLens]="false"
                    [lensWidth]="100"
                ></lib-ngx-image-zoom>    
            </div>
            <div class="divImagenPortada">
                <lib-ngx-image-zoom
                    [thumbImage]=urlImagen3
                    [zoomMode]="hover"
                    [magnification]="0.3"
                    [scrollStepSize]="0.1"
                    [enableScrollZoom]="true"
                    [enableLens]="false"
                    [lensWidth]="100"
                ></lib-ngx-image-zoom>    
            </div-->
            <br>
            <p>
                <!--ngx-text-expander
                        text="{{detalleLibro.response.list[0].description}}"
                    [max-char-count]="150"
                    less-text="Ver menos"
                    more-text="Ver más"
                    [show-ellipse]="true"> 
                </ngx-text-expander-->
                <span class="detalle"><span class="font-weight">{{detalleLibro.response.list[0].description}}</span></span>
            </p>
            <div class="tag">
                <span class="fa fa-tags"></span> 
                <!--span class="tagItem" *ngFor="let item of tagPublicacion">
                   {{item}}
                </span-->
                <!--daet-->
                <span class="tagItem" *ngFor="let item of tagPublicacion">
                    <a  (click)="prueba(item)">{{item}}</a>
                </span>
            </div>  
            <!--daet1 ini-->
            <!--div class="tag">
                <span class="fa fa-tags"></span> 
                <span class="tagItem" *ngFor="let item of relacionados">
                    <a  (click)="prueba1(item.id)">{{item.title}}</a>
                </span>
            </div-->
            <!--daet1 fin-->

        </div>
        <div class="col-sm-1"></div>
        <div class="col-sm-5">
            <div class="datosLibro">
                <p>
                    <br><span class="titulo">{{detalleLibro.response.list[0].title}}</span><br>
                    <!-- <span class="font-weight-bold">{{detalleLibro.response.list[0].subtitle}}</span> -->
                </p>
                <div class="divPrecio">
                    <div class="alert alert-danger" *ngIf="detalleLibro.response.list[0].stock==0" role="alert">
                       Producto sin Stock
                    </div>
    
                    <p *ngIf="detalleLibro.response.list[0].stock>0">
                        <span class="precio">S/ {{precioTotal | number:'1.2-2'}}</span>
                    </p>
                </div>
                <table width="100%">
                    <!--tr>
                        <td *ngIf="detalleLibro.response.list[0].title!=null&&detalleLibro.response.list[0].title!=''">Fotografia:</td>
                        <td *ngIf="detalleLibro.response.list[0].title!=null&&detalleLibro.response.list[0].title!=''">{{detalleLibro.response.list[0].title}}</td>
                    </tr-->
                    <tr>
                        <td *ngIf="detalleLibro.response.list[0].authorName!=null&&detalleLibro.response.list[0].authorName!=''">Autor</td>
                        <td *ngIf="detalleLibro.response.list[0].authorName!=null&&detalleLibro.response.list[0].authorName!=''">{{detalleLibro.response.list[0].authorName}}</td>
                    </tr>    
                    <tr>
                        <td *ngIf="detalleLibro.response.list[0].yearName!=null&&detalleLibro.response.list[0].yearName!=''">Fecha</td>
                        <td *ngIf="detalleLibro.response.list[0].yearName!=null&&detalleLibro.response.list[0].yearName!=''">{{detalleLibro.response.list[0].yearName}}</td>
                        <td>Fecha</td>
                        <td>{{detalleLibro.response.list[0].fechaPublicacion}}</td>
                    </tr>    
                    <tr>
                        <td>Tamaño</td>
                        <td>Ancho {{detalleLibro.response.list[0].width}} Alto {{detalleLibro.response.list[0].height}}</td>
                    </tr>
                    <tr>
                        <td>Formato:</td>
                        <td>JPG</td>
                    </tr>
                    <tr>
                        <td *ngIf="detalleLibro.response.list[0].diarioName!=null&&detalleLibro.response.list[0].diarioName!=''">Diario</td>
                        <td *ngIf="detalleLibro.response.list[0].diarioName!=null&&detalleLibro.response.list[0].diarioName!=''">{{detalleLibro.response.list[0].diarioName}}</td>
                    </tr>    
                    <tr>    
                        <td *ngIf="detalleLibro.response.list[0].measure!=null&&detalleLibro.response.list[0].measure!=''">Tamaño</td>
                        <td *ngIf="detalleLibro.response.list[0].measure!=null&&detalleLibro.response.list[0].measure!=''">{{detalleLibro.response.list[0].measure}}</td>
                    </tr>
                </table>
                <br/><br/>
                <p>
                    Modalidad de uso:
                </p>          
                <p> 
                    <!--daet1-->
                    <a title="licencia" class="btn btnUSo"  [ngClass]="modalidadCss(modalidad)" (click)="cambiarModalidad(modalidad)" *ngFor="let modalidad of listModalidad">{{modalidad}}</a>

                    <!-- <a class="btn btnUSo">Natural</a>
                    <a class="btn btnUSo">Comercial Uso</a>
                    <a class="btn btnUSo">Comercial Extranjero</a> -->
                </p>
                <p>{{comercialMsg}}</p>
                
                <br/><br/>
                <a *ngIf="detalleLibro.response.list[0].stock>0" class="btn btn-carrito" (click)="agregarCarrito()"><mdb-icon fas icon="shopping-cart"></mdb-icon> Agregar al Carrito</a> &nbsp;&nbsp;
                <a  *ngIf="detalleLibro.response.list[0].stock>0" class="btn btn-comprar" (click)="onComprar()"><mdb-icon fas icon="shopping-bag"></mdb-icon> Comprar</a>
                <br/>
                <br/>
                <p>
                    Compartir en: 
                    <a class="btnRedSocial" target="_blank" (click)="sharedFacebook()"><mdb-icon fab icon="facebook"></mdb-icon></a> &nbsp;
                    <a class="btnRedSocial" target="_blank" (click)="sharedTwitter()"><mdb-icon fab icon="twitter"></mdb-icon></a> &nbsp;
                    <a class="btnRedSocial" target="_blank" (click)="sharedWhatsapp()"><mdb-icon fab icon="whatsapp"></mdb-icon></a>
           
                </p>
                

                    <!-- <input *ngIf="detalleLibro.response.list[0].stock>0" class="form-control w-auto" type="number" onkeypress="return event.charCode >= 48" (change)="obtenerDetalleLibroAgregarLibros(detalleLibro.response.list[0].id);" [(ngModel)]="cantidadLibro" min="0" max="{{stockLibro}}"> -->
            </div>
        </div>
        <!-- <div class="col-sm-3">
            <div class="divPrecio">
                <div class="alert alert-danger" *ngIf="detalleLibro.response.list[0].stock==0" role="alert">
                   Producto sin Stock
                </div>

                <p class="text-right" *ngIf="detalleLibro.response.list[0].stock>0">
                    <span class="precio">S/ {{precioTotal | number:'1.2-2'}}</span>
                </p>
                 <a  *ngIf="detalleLibro.response.list[0].stock>0" class="btn btn-carrito w-100" (click)="agregarCarrito()"><mdb-icon fas icon="shopping-cart"></mdb-icon> Agregar al Carrito</a> <br><br>
                <a  *ngIf="detalleLibro.response.list[0].stock>0" class="btn btn-comprar w-100" (click)="onComprar()"><mdb-icon fas icon="shopping-bag"></mdb-icon> Comprar</a>
                
                <br><br><br><br>  
                <p>
                    <span>Comparte en:</span><br><br>
                        <a class="btnRedSocial" target="_blank" href="http://www.facebook.com/sharer.php?u=https://CatalogoDigital.bnp.gob.pe%2F%23%2Fdetalle/{{detalleLibro.response.list[0].id}}"><mdb-icon fab icon="facebook-f"></mdb-icon></a> &nbsp;
                        <a class="btnRedSocial" target="_blank" href="https://twitter.com/intent/tweet?text=Libro&url=https://CatalogoDigital.bnp.gob.pe%2F%23%2Fdetalle/{{detalleLibro.response.list[0].id}}"><mdb-icon fab icon="twitter"></mdb-icon></a> &nbsp;
                        <a class="btnRedSocial" target="_blank" href="https://api.whatsapp.com/send?text=https://CatalogoDigital.bnp.gob.pe%2F%23%2Fdetalle/{{detalleLibro.response.list[0].id}}"><mdb-icon fab icon="whatsapp"></mdb-icon></a>
                </p>

            </div>
        </div> -->
        <!-- <div class="col-sm-12 p-5 mt-5 mb-5">
            <p>
                <span class="h4-responsive font-weight-bold">Recomendados</span><br>
                <img src="/assets/image/portafolio/line_novedades.png" width="10%">
            </p>
            <ngx-slick-carousel class="carousel" 
            #slickModal="slick-carousel" 
            [config]="slideConfig" 
            (init)="slickInit($event)"
            (breakpoint)="breakpoint($event)"
            (afterChange)="afterChange($event)"
            (beforeChange)="beforeChange($event)">
            <div ngxSlickItem *ngFor="let novedad of librosRecomendados.response.list" class="slide m-3">
              <div class="divLibroNovedades w-100">
                <p class="text-center">
                  <a [routerLink]="['/detalle',novedad.id]">
                    <img src="{{novedad.image}}" (click)="cargarDetalleLibro(novedad.id)" class="z-depth-5" style="display: initial;" width="150px"/>
                  </a>
                </p> 
                <br>     
                <p class="text-left">
                  <span class="title">{{novedad.title}}</span><br>
                  <span class="subtitle">{{novedad.subtitle}}</span>

                </p>
                <p  class="text-center">
                  <span class="price">S/{{novedad.price}}</span>
                </p>
              </div>        
              
           
              
            </div>
            </ngx-slick-carousel>
        </div> -->
        <hr>
        <div class="col-sm-6 mb-3">
            <p class="font-weight-bold">Pagos 100% seguros<br>   <img src="/assets/image/portafolio/line_pagos.png" width="35%"></p>
            <p >
                <img src="/assets/image/portafolio/p1.png" width="10%">&nbsp;
                <img src="/assets/image/portafolio/p2.png" width="10%">&nbsp;
                <img src="/assets/image/portafolio/p3.png" width="15%">&nbsp;
                <img src="/assets/image/portafolio/p4.png" width="20%">&nbsp;

            </p>
        </div>
    
    </div>
</div>